<i18n
  src="@/locales/views/agro_exporter/production/query_container_export/show_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_process_containers')"
    :params="{
      agro_exporter_process_id: agro_exporter_process_id
    }"
  />

  <template v-if="load_general_data">
    <bread-crumbs :labels="[module_name, agro_exporter_process.name]" />

    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200" v-if="container">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.container_code") }}
                </dt>
                <dd class="content-data">
                  {{ container.container_code }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.customer") }}
                </dt>
                <dd class="content-data">
                  {{ container.customer?.name }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.week") }}
                </dt>
                <dd class="content-data">
                  {{ container.week }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.status") }}
                </dt>
                <dd class="content-data">
                  <container-status :status_id="container.status_id" />
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <div class="sm:col-span-3">
                  <dt class="label-data">
                    <template
                      v-if="container.exportation?.exportation_type_id == 0"
                    >
                      {{ $t("model.exportation.booking_code_0") }}
                    </template>
                    <template
                      v-else-if="
                        container.exportation?.exportation_type_id == 1
                      "
                    >
                      {{ $t("model.exportation.booking_code_1") }}
                    </template>
                  </dt>
                  <dd class="content-data">
                    <exportation-type
                      :exportation_type_id="
                        container.exportation?.exportation_type_id
                      "
                      only_icon="true"
                    /><span class="icon-space"></span
                    >{{ container.exportation?.booking_code }}
                  </dd>
                </div>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.packing_house") }}
                </dt>
                <dd class="content-data">
                  {{ container.packing_house_names.join(", ") }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.load_date") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(container.load_date) }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.waybill") }}
                </dt>
                <dd class="content-data">
                  {{ container.waybill }}
                </dd>
              </div>
              <div class="sm:col-span-3" v-if="container.brand_name">
                <dt class="label-data">
                  {{ $t("model.container.exporter_process_brand") }}
                </dt>
                <dd class="content-data">
                  {{ container.brand_name }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.rows_package_groups") }}
                </dt>
                <dd class="content-data">
                  {{ container.rows_package_groups }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.cols_package_groups") }}
                </dt>
                <dd class="content-data">
                  {{ container.cols_package_groups }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.thermo_code") }}
                </dt>
                <dd class="content-data">
                  {{ container.thermo_code }}
                </dd>
              </div>
              <div
                class="sm:col-span-3"
                v-if="
                  container.exporter_process_container
                    ?.agro_exporter_package_wrapper
                "
              >
                <dt class="label-data">
                  {{
                    $t(
                      "model.exporter_process_container.agro_exporter_package_wrapper_id"
                    )
                  }}
                </dt>
                <dd class="content-data">
                  {{
                    container.exporter_process_container
                      ?.agro_exporter_package_wrapper?.name
                  }}
                </dd>
              </div>
            </div>

            <div
              v-if="container.thermo_code"
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            >
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.thermo_code") }}
                </dt>
                <dd class="content-data">
                  {{ container.thermo_code }}
                </dd>
              </div>
            </div>

            <div
              v-if="container.container_sealings.length > 0"
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            >
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.container_sealings") }}
                </dt>
                <dd class="content-data">
                  <ul>
                    <li
                      v-for="container_sealing in container.container_sealings"
                      :key="container_sealing.id"
                    >
                      <span class="text-slate-600">
                        {{ container_sealing.export_sealing.name }}:
                      </span>
                      {{ container_sealing.value }}
                    </li>
                  </ul>
                </dd>
              </div>
            </div>

            <!-- Section for container attribute values -->
            <div
              v-if="
                container.container_attribute_values &&
                container.container_attribute_values.length > 0
              "
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            >
              <div
                v-for="attribute_value in container.container_attribute_values"
                :key="attribute_value.id"
                class="sm:col-span-3"
              >
                <dt class="label-data">
                  {{
                    attribute_value.exporter_process_container_attribute
                      .agro_exporter_container_attribute.name
                  }}
                </dt>
                <dd class="content-data">
                  <template
                    v-if="
                      attribute_value.exporter_process_container_attribute
                        .data_type_id === 2 &&
                      attribute_value.exporter_process_container_attribute_option
                    "
                  >
                    {{
                      attribute_value
                        .exporter_process_container_attribute_option.value ||
                      attribute_value
                        .exporter_process_container_attribute_option.value
                    }}
                  </template>
                  <template v-else>
                    {{ attribute_value.value }}
                  </template>
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <dt class="label-data">
                  {{ $t("model.container.private_comments") }}
                  <em
                    class="text-sm text-green-800 bg-green-100 p-1 rounded-md"
                  >
                    {{ $t("model.container.describe_private_comments") }}
                  </em>
                </dt>
                <dd class="content-data">
                  {{ container.private_comments }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <dt class="label-data">
                  {{ $t("model.container.comments") }}
                  <em class="text-sm text-red-800 bg-red-100 p-1 rounded-md">
                    {{ $t("model.container.describe_comments") }}
                  </em>
                </dt>
                <dd class="content-data">
                  {{ container.comments }}
                </dd>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-footer">
          <div class="panel-footer-actions">
            <template
              v-for="(packing_list_format, idx) in packing_list_formats"
              :key="idx"
            >
              <button
                type="button"
                @click.prevent="downloadPackingListXlsx(packing_list_format)"
                class="btn-white"
              >
                <i
                  :class="[
                    'fa-solid',
                    packing_list_format.downloading
                      ? 'fa-sync fa-spin'
                      : 'fa-file-excel'
                  ]"
                ></i>
                <span class="space-icon"></span>{{ packing_list_format.name }}
              </button>
              <span class="space-actions" />
            </template>
            <button
              type="button"
              @click.prevent="downloadControlUnionRepXlsx()"
              class="btn-white"
            >
              <i
                :class="[
                  'fa-solid',
                  downloading_control_union
                    ? 'fa-sync fa-spin'
                    : 'fa-file-excel'
                ]"
              >
              </i>
              <span class="space-icon"></span>Control Union
            </button>
            <span class="space-actions" />
          </div>
        </div>
      </div>
    </div>

    <container-planning
      v-if="container?.container_planning"
      :container_planning="container?.container_planning"
      :agro_exporter_process_id="agro_exporter_process_id"
      :container_id="container_id"
    />

    <div class="my-8">
      <div class="flex flex-row">
        <div class="panel-plain-label">
          <badge-default
            :label="
              container_attachments.length +
              ' ' +
              $t('labels.total_number_attachs')
            "
          />
        </div>
      </div>
      <div class="mt-8 flex flex-col">
        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-cell">
                      {{
                        $t(
                          "model.container.container_attachments.exporter_process_container_file"
                        )
                      }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{
                        $t(
                          "model.container.container_attachments.container_attach"
                        )
                      }}
                    </th>
                    <th scope="col" class="table-header-cell"></th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr
                    class="table-row"
                    v-for="attachment in container_attachments"
                    :key="attachment.id"
                  >
                    <td class="table-cell">
                      {{ attachment.exporter_process_container_file?.name }}
                    </td>
                    <td class="table-cell-main">
                      {{ attachment.container_attach.blob.filename }}
                    </td>
                    <td class="table-cell-action">
                      <button
                        class="btn-white inline-flex"
                        @click.prevent="downloadContainerAttachment(attachment)"
                      >
                        <i
                          :class="[
                            'fa-solid ',
                            attachment.downloading
                              ? ' fa-sppiner'
                              : ' fa-download'
                          ]"
                        ></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/production/query_container_export/show_container.js";
import ContainerPlanning from "@/components/views/agro_exporter/production/query_container_export/show_container/ContainerPlanning.vue";
import ContainerStatus from "@/components/views/agro_exporter/production/shared/container/ContainerStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";

export default {
  name: "AEProductionQueryContainerExportNewContainer",
  components: {
    ContainerStatus,
    ExportationType,
    ContainerPlanning
  },
  props: ["agro_exporter_process_id", "container_id", "agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      proc_button_destroy: false,
      downloading_control_union: false,
      agro_exporter_process: {},
      container: null,
      container_attachments: [],
      packing_list_formats: []
    };
  },
  methods: {
    fetchData: async function () {
      await this.fetchContainer();
      await this.fetchPackingListFormats();
      await this.fetchContainerAttachments();
      await this.fetchAgroExporterProcess();
      this.load_general_data = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer(this.container_id);

      this.container = response.data;
    },
    fetchContainerAttachments: async function () {
      let response = await Requester.fetchContainerAttachments(
        this.container_id
      );

      this.container_attachments = response.data.map(container_attachment => {
        return {
          ...container_attachment,
          downloading: false
        };
      });
    },
    fetchPackingListFormats: async function () {
      let response = await Requester.fetchPackingListFormats(this.container_id);
      this.packing_list_formats = response.data;

      this.packing_list_formats.forEach(packing_list_format => {
        packing_list_format["downloading"] = false;
      });
    },
    downloadControlUnionRepXlsx: async function () {
      this.downloading_control_union = true;
      try {
        let response = await Requester.downloadControlUnionRepXlsx({
          container_id: this.container_id
        });

        const file = response.data;
        this.downloadFile(file, "control_union_rep.xlsx");
      } catch (error) {
        error;
      }
      this.downloading_control_union = false;
    },
    downloadPackingListXlsx: async function (packing_list_format) {
      packing_list_format.downloading = true;
      try {
        let response = await Requester.downloadPackingListXlsx(
          this.container_id,
          packing_list_format.id
        );

        const file = response.data;
        this.downloadFile(
          file,
          `PackingList-${this.container.container_code}.xlsx`
        );
      } catch (error) {
        error;
      }
      packing_list_format.downloading = false;
    },
    containerAttachments: function (exporter_process_container_file_id) {
      return this.container_attachments.filter(
        container_attachment =>
          container_attachment.exporter_process_container_file_id ===
          exporter_process_container_file_id
      );
    },
    downloadContainerAttachment: async function (container_attachment) {
      container_attachment.downloading = true;
      try {
        var response = await Requester.downloadContainerAttachment(
          this.container_id,
          container_attachment.id
        );
        const file = response.data;
        this.downloadFile(
          file,
          container_attachment.container_attach.blob.filename
        );
      } catch (error) {
        error;
      }
      container_attachment.downloading = false;
    },
    goToShowProcess: function () {
      this.$router.push({
        name: this.routeName("show_process_containers"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated();
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  }
};
</script>
